import { required } from "../../../../../../helpers/forms/validate.js";
import useSearcherDestinationInput from "../../../../../../hooks/common/searchers/inputs/useDestinationInput.js";
import useIsMobile from "../../../../../../hooks/device/useIsMobile.js";
import { useSearcherActivitiesProps } from "../../context/index.js";
import useSearcherActivitiesDefaultValues from "../../hooks/useSearcherActivitiesDefaultValues.js";
const useDestinationInput = ()=>{
    const props = useSearcherActivitiesProps();
    const { config , destination , disableDestination =false , types =[]  } = props ?? {};
    const { literals  } = config ?? {};
    const { destinationLabel =''  } = literals ?? {};
    const isMobile = useIsMobile();
    const destinationTypes = {
        CIU: literals?.CIU,
        ZON: literals?.ZON,
        ISL: literals?.ISL,
        ACT: literals?.ACT
    };
    const commonProps = useSearcherDestinationInput({
        ...destination,
        validate: [
            required()
        ],
        label: destinationLabel,
        defaultValue: useSearcherActivitiesDefaultValues(props).destination,
        types: types,
        disabled: disableDestination
    });
    if (isMobile) {
        const { config  } = props ?? {};
        const { literals  } = config ?? {};
        const { destinationModalLabel =''  } = literals ?? {};
        return {
            ...commonProps,
            literals: {
                ...destinationTypes,
                modalTitle: destinationModalLabel
            }
        };
    }
    return commonProps;
};
export default useDestinationInput;

//# sourceMappingURL=useDestinationInput.js.map